import React, { useEffect } from "react"
import styled from "styled-components"
import Colors from "../../theme/Colors"
import {
  notPhone,
  onPhone,
  OnDesktop,
  NotDesktop,
  onTablet,
} from "../../theme/MediaQueries"
import { WidgetTitleText } from "../../theme/Typography"
import CheckItem from "../CheckItem"
import { AddonContainer, ArrowDown, WidgetTitleContainer } from "./styles"

const Container = styled.div`
  background: white;
  ${notPhone} {
    box-shadow: 0 4px 8px 2px rgba(0, 0, 0, 0.23);
  }
`

const WidgetTitle = styled.div`
  ${WidgetTitleText};
  color: ${Colors.blue};
`
const CheckItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  ${onPhone} {
    width: 50%;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 10px 0;
  }
  ${onTablet} {
    margin: 4px 0;
  }
`

const WidgetAttributes = {
  id: "ffg-widget",
  "data-hero": true,
  src: `${process.env.WIDGET_URL}/BankForm.js`,
}

const Widget = ({ text }) => {
  useEffect(() => {
    const el = document.getElementById("widget-container")
    const widgetScript = document.createElement("script")
    Object.entries(WidgetAttributes).forEach(([attr, value]) =>
      widgetScript.setAttribute(attr, value)
    )
    el.appendChild(widgetScript)
  }, [])

  return (
    <Container>
      <AddonContainer>
        <WidgetTitleContainer
          style={{
            backgroundColor: Colors.lightestgrey,
            zIndex: 200,
            padding: "8px 0",
            width: "100%",
          }}
        >
          <NotDesktop>
            <WidgetTitle>Kreditvergleich</WidgetTitle>
          </NotDesktop>
          <OnDesktop>
            <WidgetTitle>
              Kreditvergleich - Ihre Träume werden jetzt Wirklichkeit
            </WidgetTitle>
          </OnDesktop>
        </WidgetTitleContainer>
        <ArrowDown color={Colors.lightestgrey} style={{ zIndex: 200 }} />
      </AddonContainer>
      <AddonContainer style={{ marginTop: -10 }}>
        <WidgetTitleContainer
          style={{
            backgroundColor: Colors.lightestblue,
            zIndex: 100,
            padding: 0,
            width: "100%",
          }}
        >
          <CheckItemsContainer>
            <CheckItem>
              <OnDesktop>100% kostenlos für Sie</OnDesktop>
              <NotDesktop>100% kostenlos</NotDesktop>
            </CheckItem>
            <CheckItem>Ohne Schufa-Eintrag</CheckItem>
            <CheckItem>Unverbindliche Angebote</CheckItem>
          </CheckItemsContainer>
        </WidgetTitleContainer>
        <ArrowDown color={Colors.lightestblue} />
      </AddonContainer>

      <div id="widget-container" />
    </Container>
  )
}
Widget.propTypes = {}

Widget.defaultProps = {}

export default Widget
